import { apiClient } from './client';

export interface SessionResponse {
  id: number;
  token: string;
  user_id: number;
}

export const authApi = {
  login: (email: string, password: string) =>
    apiClient.post<SessionResponse>('/api/auth/login', { email, password }),

  loginUma: (token: string) => apiClient.post<SessionResponse>('/api/auth/login/uma', { token }),

  logout: () => apiClient.delete('/api/auth/session'),

  resetPassword: (email: string, base_url: string) =>
    apiClient.post('/api/auth/reset-password', { email, base_url }),

  updatePassword: (reset_token: string, password: string, password_confirmation: string) =>
    apiClient.patch('/api/auth/password', { reset_token, password, password_confirmation }),
};
